import { PIPELINE_STEPS } from "@/lib/pilotageOperator";
import { CheckCircle2, Circle, Loader2, XCircle, HelpCircle, AlertTriangle, Ban } from "lucide-react";

// COCKPIT.FINAL.5 — symboles/états DISTINCTS. result_unknown ≠ failed (visuellement distinct).
const ICON = {
  executed: { I: CheckCircle2, c: "#22C55E" },
  executing: { I: Loader2, c: "#3B82F6", spin: true },
  pending: { I: Circle, c: "#525252" },
  failed: { I: XCircle, c: "#EF4444" },
  result_unknown: { I: AlertTriangle, c: "#F59E0B" },
  cancelled: { I: Ban, c: "#A3A3A3" },
  unknown: { I: HelpCircle, c: "#A3A3A3" },
};

const fmtDur = (ms) => {
  if (ms == null) return null;
  return ms >= 1000 ? `${(ms / 1000).toFixed(1)} s` : `${Math.round(ms)} ms`;
};

// Pipeline visuel PREPARE→POSITION HOLD. Lecture seule : alimenté par les preuves backend (jamais de timer).
export default function OperatorFlightPipeline({ pipeline }) {
  const steps = pipeline?.steps || PIPELINE_STEPS.map((s) => ({ ...s, state: "pending" }));
  return (
    <div data-testid="operator-pipeline" className="rounded-sm border border-white/10 bg-white/[0.02] px-3 py-2">
      <div className="flex items-center gap-2 mb-1.5">
        <span className="text-[9px] uppercase tracking-widest text-white/50">Séquence de vol</span>
        {pipeline?.terminal && <span data-testid="pipeline-terminal" className="ml-auto font-mono text-[9px] text-red-400">{pipeline.terminal}</span>}
      </div>
      <div className="flex flex-col gap-0.5">
        {steps.map((s) => {
          const m = ICON[s.state] || ICON.unknown;
          const dur = fmtDur(s.durationMs);
          return (
            <div key={s.key} data-testid={`pipeline-${s.key}`} data-state={s.state}
              className="flex items-center gap-2 font-mono text-[9px] uppercase tracking-wider" style={{ color: m.c }}>
              <m.I size={11} className={m.spin ? "animate-spin shrink-0" : "shrink-0"} />
              <span className="flex-1">{s.label}</span>
              {dur && <span data-testid={`pipeline-${s.key}-dur`} className="text-white/40">{dur}</span>}
              {s.state === "result_unknown" && <span className="text-[#F59E0B]">?</span>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
